import React, { useState, useEffect, Fragment } from "react";
import { TextField, Button, Container, Typography, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import Decimal from 'decimal.js';

function App() {
  Decimal.set({ toExpPos: 50, precision: 50 });

  const [number1, setNumber1] = useState("0");
  const [number2, setNumber2] = useState("0");
  const [number3, setNumber3] = useState("0");
  const [number4, setNumber4] = useState("0");

  const [operation1, setOperation1] = useState("+");
  const [operation2, setOperation2] = useState("+");
  const [operation3, setOperation3] = useState("+");

  const [result, setResult] = useState([null]);
  const [roundedResult, setRoundedResult] = useState(null);
  const [hint, setHint] = useState(null);

  const [rounding, setRounding] = useState("maths");

  const format = (s) => {
    let parts = s.toString().replace(/ /g, '').split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
  };

  const calc = (n1, n2, o) => {
    let res = null;
    if (o === "+") {
      res = n1.plus(n2);
    } else if (o === "-") {
      res = n1.minus(n2);
    } else if (o === "*") {
      res = n1.times(n2);
    } else if (o === "/") {
      if (n2.isZero()) throw "Ошибка (O_o): Деление на 0!";
      else res = n1.dividedBy(n2);
    }
    return res;
  }

  const handleCalculation = () => {
    const numbers = [number1, number2, number3, number4];
    const isBad = (s) => /\s/g.test(s) && format(s) != s;
    
    if (numbers.some(n => isBad(n))) {
      setHint(numbers.map(format));
    } else {
      setHint(null);
    }

    if (numbers.some(n => !n)) {
      setRoundedResult("");
      setResult("");
      return;
    }

    let res = null;
    try {
      const n1 = new Decimal(number1.replace(/ /g, ''));
      const n2 = new Decimal(number2.replace(/ /g, ''));
      const n3 = new Decimal(number3.replace(/ /g, ''));
      const n4 = new Decimal(number4.replace(/ /g, ''));
      res = calc(n2, n3, operation2);
      if (['*', '/'].includes(operation3) && ['+', '-'].includes(operation1)) {
        res = calc(n1, calc(res, n4, operation3), operation1);
      } else {
        res = calc(calc(n1, res, operation1), n4, operation3);
      }
    } catch (e) {
      setRoundedResult("");
      setResult(e.toString());
      return;
    }

    setResult(format(res.toDecimalPlaces(6)));

    let rounded = null;
    if (rounding == "maths") {
      Decimal.rounding = Decimal.ROUND_HALF_CEIL;
      rounded = res.round();
    } else if (rounding == "bank") {
      Decimal.rounding = Decimal.ROUND_HALF_EVEN;
      rounded = res.round();
    } else {
      rounded = res.trunc();
    }

    setRoundedResult(format(rounded));
  };

  useEffect(() => {
    handleCalculation();
  }, [number1, number2, number3, number4, operation1, operation2, operation3, rounding]);

 
  const renderField = (v, sv) => {
      return <TextField
          style={{ flex: 1, marginRight: '10px', marginLeft: '10px' }}
          variant="outlined"
          value={v}
          type="number"
          onChange={e => sv(e.target.value.replace(",", ".").replace(/[^\d.-]/g, ""))}
        />
  }

  const renderOperation  = (o, so) => {
    return <FormControl variant="outlined" style={{ flex: 0.3 }}>
      <Select
        value={o}
        onChange={(e) => so(e.target.value)}
      >
        <MenuItem value="+">+</MenuItem>
        <MenuItem value="-">-</MenuItem>
        <MenuItem value="*">*</MenuItem>
        <MenuItem value="/">/</MenuItem>
      </Select>
    </FormControl>
  }

  return (
    <Container maxWidth="lg">
      <Typography variant="h6" align="center" gutterBottom>
        Калькулятор - Олешко Владислав Юрьевич: 4 курс, 4 группа, 2023 год
      </Typography>

      <div style={{ marginTop: "30vh" }}></div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        {renderField(number1, setNumber1)}
        {renderOperation(operation1, setOperation1)}
        {renderField(number2, setNumber2)}
        {renderOperation(operation2, setOperation2)}
        {renderField(number3, setNumber3)}
        {renderOperation(operation3, setOperation3)}
        {renderField(number4, setNumber4)}
      </div>

      {hint &&
        <Fragment><Typography variant="caption" style={{ color: "#FFA500" }}>
          Подсказка: неверная расстановка пробелов: &nbsp;
          <Typography variant="solid" color="primary" noWrap>{hint[0]}</Typography> &nbsp;{operation1}&nbsp;
          <Typography variant="solid" color="primary" noWrap>{hint[1]}</Typography> &nbsp;{operation2}&nbsp;
          <Typography variant="solid" color="primary" noWrap>{hint[2]}</Typography> &nbsp;{operation3}&nbsp;
          <Typography variant="solid" color="primary" noWrap>{hint[3]}</Typography>
        </Typography></Fragment>
      }

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <Typography variant="h5" gutterBottom>
          <b>=</b> {result}
        </Typography>
        <div  style={{ display: 'flex',justifyContent: 'space-between', marginBottom: '20px', alignItems: 'center'}}>
          <Typography variant="h5" style={{paddingRight: '20px'}}>
            {roundedResult}
          </Typography>
          <Select
            value={rounding}
            onChange={(e) => setRounding(e.target.value)}
            style={{minWidth: "5em"}}
          >
            <MenuItem value="maths">Математическое</MenuItem>
            <MenuItem value="bank">Банковское</MenuItem>
            <MenuItem value="cut">Усечение</MenuItem>
          </Select>
        </div>
      </div>
    </Container>
  );
}

export default App;
